<template>
  <div v-if="error" role="alert">
    {{ error }}
    <v-btn data-mp-name="terms-content.retry" @click="retryCount++">Retry</v-btn>
  </div>
  <div v-else-if="loading">Loading terms…</div>
  <div v-else v-html="safeHtml"></div>
</template>

<script setup>
import { computed, ref, watch } from 'vue'
import { useKinectinStore } from '@/store/kinectin.js'
import api from '@/service/Api.js'
import { getUserSession } from '@/service/UserService.js'
import defaultHtml from '../../../api/common/defaultTerms.html?raw'
import { sanitizeTermsHtml } from '@/service/termsHtml.js'

const props = defineProps({ terms: { type: Object, default: null } })
const store = useKinectinStore()
const loadedTerms = ref(null)
const loading = ref(false)
const error = ref('')
const retryCount = ref(0)
const safeHtml = computed(() => sanitizeTermsHtml((props.terms || loadedTerms.value)?.html ?? defaultHtml))
watch(() => [props.terms, store.userProfile?.orgId, retryCount.value], async (_, __, onCleanup) => {
  let stale = false
  onCleanup(() => { stale = true })
  error.value = ''
  loading.value = false
  loadedTerms.value = null
  if (props.terms) return
  loading.value = true
  try {
    const { token } = await getUserSession()
    if (!token || stale) return
    const { response } = await api.getTerms()
    if (!stale) loadedTerms.value = response
  } catch {
    if (!stale) error.value = 'Unable to load terms. Please try again.'
  } finally {
    if (!stale) loading.value = false
  }
}, { immediate: true })
</script>
